export const breakpoints = {
    mobile: {
        size: 320,
        active: false,
    },
    mobilePlus: {
        size: 480,
        active: false,
    },
    tabletPortrait: {
        size: 768,
        active: false,
    },
    tabletLandscape: {
        size: 1024,
        active: false,
    },
    laptop: {
        size: 1260,
        active: false,
    },
    desktop: {
        size: 1600,
        active: false,
    },
};
